const newsRouter = {
  path: "/news",
  component: () => import("@/views/index"),
  meta: {
    title: "企业资讯",
    icon: "el-icon-news"
  },
  children: [
    {
      path: "list",
      component: () => import("@/views/news/index"),
      name: "NewsList",
      meta: { title: "资讯列表" }
    },
    {
      path: "add",
      component: () => import("@/views/news/article"),
      name: "NewsAdd",
      meta: { title: "添加资讯" }
    },
    {
      path: "edit",
      component: () => import("@/views/news/article"),
      name: "NewsEdit",
      meta: { title: "编辑资讯" }
    }
  ]
};
export default newsRouter;
